import {
  HttpClient as BaseClient,
  defaultAxiosConfig,
} from 'module/api/http-client';
import axiosStatic, { AxiosInstance } from 'axios';
import { map, Observable, of, shareReplay } from 'rxjs';

const axiosInstance = (): Observable<AxiosInstance> =>
  of([1]).pipe(
    map(() => axiosStatic.create(defaultAxiosConfig)),
    shareReplay(1),
  );

abstract class HttpClient extends BaseClient {
  public constructor() {
    super(axiosInstance);
  }
}

export { HttpClient };
